import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-adm-admins-list',
  templateUrl: './adm-admins-list.component.html',
  styleUrls: ['./adm-admins-list.component.css']
})
export class AdmAdminsListComponent implements OnInit {
  
  public breadcrumb : any;

  response;
    constructor(private adminService:AdminService,
                private toast : ToastrService){}

  

  async ngOnInit() {
    await this.loadData();
    this.breadcrumb = {
      'mainlabel': 'Lista de administradores'
      };
    
  }

  async loadData()
  {
    var result = await firstValueFrom(this.adminService.getListaAdmins());
    if(result && result.length>0)
      this.response=result;
    else
      this.toast.error('No se pudo obtener información','error');
  }

}
